// Categorias "macro" de contato (segmento do cliente).
// Cada valor DEVE existir, byte-a-byte, na tabela de "Tipos de contato" da conta
// Tiny — hoje todas as 9 já estão cadastradas. O valor escolhido é enviado ao Tiny
// no campo `tipos_contato` (ver buildTiposContato) e vira o segmento do contato.
//
// Obs.: "Lazer, Esporte e Entretenimento" tem 31 caracteres; o campo `tipo` da API
// v2 do Tiny é máx. 30. Se essa macro específica não colar, é truncamento da API.
export const TIPOS_CONTATO: string[] = [
  'Cliente Final',
  'Eventos e Produtoras',
  'Turismo e Hospitalidade',
  'Lazer, Esporte e Entretenimento',
  'Saúde e Beleza',
  'Educação',
  'Corporativo',
  'Institucional',
  'Setor Público',
];

// Converte o tipo de contato escolhido no formato aceito pelo Tiny
// (`contato.tipos_contato[] = { tipo }`). Retorna [] quando nada foi selecionado,
// para que o campo seja simplesmente omitido do payload.
export function buildTiposContato(tipoContato: string): { tipo: string }[] {
  const tipo = (tipoContato || '').trim();
  return tipo ? [{ tipo }] : [];
}
